exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".media-zoom[data-v-d3acbb84]{position:fixed;top:0;left:0;right:0;bottom:0;z-index:12;background:#fff}.media-zoom .icon-close-paddings[data-v-d3acbb84]{padding:20px}@media (max-width: 767px){.media-zoom .icon-close-paddings[data-v-d3acbb84]{padding:0 0px 0px 0px;margin-bottom:env(safe-area-inset-bottom)}}.media-zoom__close[data-v-d3acbb84]{position:absolute;right:5px;top:5px;z-index:1}@media (max-width: 767px){.media-zoom__close[data-v-d3acbb84]{bottom:4%;border-radius:50%;top:unset;background-color:white;-webkit-transform:translate(50%, 0px);-ms-transform:translate(50%, 0px);transform:translate(50%, 0px);right:50%}}\n", ""]);

// exports
